import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    articles: [],
    currentArticle: null,
    loading: false,
    error: null
  },
  mutations: {
    SET_ARTICLES(state, articles) {
      state.articles = articles;
    },
    SET_CURRENT_ARTICLE(state, article) {
      state.currentArticle = article;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    // 获取所有文章
    async fetchArticles({ commit }) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.get('/api/articles');
        commit('SET_ARTICLES', response.data.data);
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message || '获取文章列表失败');
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 获取单个文章
    async fetchArticle({ commit }, articleId) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.get(`/api/articles/${articleId}`);
        commit('SET_CURRENT_ARTICLE', response.data.data);
        commit('SET_ERROR', null);
        return response.data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || '获取文章详情失败');
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 创建新文章
    async createArticle({ commit }, articleData) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.post('/api/articles', articleData);
        commit('SET_ERROR', null);
        return response.data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || '创建文章失败');
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 更新文章
    async updateArticle({ commit }, { id, data }) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.put(`/api/articles/${id}`, data);
        commit('SET_ERROR', null);
        return response.data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || '更新文章失败');
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 删除文章
    async deleteArticle({ commit }, articleId) {
      commit('SET_LOADING', true);
      try {
        await axios.delete(`/api/articles/${articleId}`);
        commit('SET_ERROR', null);
        return true;
      } catch (error) {
        commit('SET_ERROR', error.message || '删除文章失败');
        return false;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 发布文章
    async publishArticle({ commit }, articleId) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.post(`/api/articles/${articleId}/publish`);
        commit('SET_ERROR', null);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error.message || '发布文章失败');
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // AI生成文章
    async generateArticle({ commit }, { prompt, category }) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.post('/api/ai/generate-article', { prompt, category });
        commit('SET_ERROR', null);
        return response.data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'AI生成文章失败');
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async startBatchGeneration({ commit }, payload) {
      try {
        const response = await axios.post('/api/ai/generate-batch', payload);
        commit('SET_ERROR', null);
        return response.data.data;
      } catch (error) {
        const message = error.response?.data?.message || error.message || '批量生成任务创建失败';
        commit('SET_ERROR', message);
        throw new Error(message);
      }
    },

    async fetchBatchGeneration({ commit }, jobId) {
      try {
        const response = await axios.get(`/api/ai/batch-jobs/${jobId}`);
        commit('SET_ERROR', null);
        return response.data.data;
      } catch (error) {
        const message = error.response?.data?.message || error.message || '获取批量生成进度失败';
        commit('SET_ERROR', message);
        throw new Error(message);
      }
    }
  },
  getters: {
    getArticleById: state => id => {
      return state.articles.find(article => article._id === id);
    }
  }
}); 
